import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { DwmGenericServiceService } from '../_DWM-Generic-Services/generic-service.service';

@Component({
  selector: 'app-dwm-setup',
  templateUrl: './dwm-setup.component.html',
  styleUrls: ['./dwm-setup.component.scss']
})
export class DwmSetupComponent implements OnInit {
  buttonColorName: any;
  pmsYears: any = [];
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  selectedYearForDWM: any = null;
  isCurrentYearSelected: boolean = false;
  errorMessage: string = '';
  cutOffDate: number | null = null;
  isInvalidCutOffDate = false;
  selectedSubAdmin: any | null = null;
  allCategoriesList: any[] = [];
  employeeList: any[] = [];
  selectedCategory: string | null = null;
  editableIndex: any;
  EditData = false;
  newCategoryName: string = '';
  showAddCategoryInput: boolean = false;
  dropdownSettings: IDropdownSettings = {};
  eodSaved: boolean = false;
  setupSaved: boolean = false;
  showEodInput: boolean = false;
  eodTime: string = '07:15';
  monthlyDwm: number | null = null;
  yearlyDwm: number | null = null;
  dwmSetupId: any;

  userIsAdminTypes: any = null;

  constructor(
    private datePipe: DatePipe,
    public sharedService: SharedService,
    private loadingService: LoaderService,
    public dialogRef: MatDialogRef<DwmSetupComponent>,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private PdfDownload: PdfDownloadService,
    private dataRefreshService: DataRefreshService,
    private dwmGenericServiceService: DwmGenericServiceService
  ) {}

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.getpmsyearlist();
  }

  ionViewWillEnter() {
    this.userIsAdminTypes = this.dwmGenericServiceService.checkIsLoggedInUserIsAdmin();
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      // console.log('fiscal year..', this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  defaultCallFunctionsList() {
    this.getCategories();
    // this.getDWMSetup();
    this.getRnDEmployees();
  }

  selectYearSetup(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    this.defaultCallFunctionsList();
  }

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    this.isCurrentYearSelected = year === currentFiscalYear;
    this.resetSetupData();
    this.getCategories();
    this.getRnDEmployees();
    this.getDWMSetup(); //
  }

  resetSetupData() {
    this.cutOffDate = null;
    this.monthlyDwm = null;
    this.yearlyDwm = null;
    this.eodTime = '07:15';
    this.selectedSubAdmin = null;
    this.dwmSetupId = null;
  }

  onClickback() {
    this.router.navigate(['/home/hrportal/dwmplus']);
  }

  preventInvalidTimeInput(event: KeyboardEvent) {
    const allowedChars = /[0-9:]/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

  // ====================================================== Cut Off Date ====================================

  validateCutOffDate() {
    const date = this.cutOffDate;
    this.isInvalidCutOffDate = !date || date < 1 || date > 31;
  }

  //  ========================================  Validate Monthly / Yearly DWM =======================

  validateOneRequired() {
    if (!this.monthlyDwm && !this.yearlyDwm) {
      return false;
    }
    return true;
  }

  // ======================================= R & D Admin Employees ================================

  getRnDEmployees() {
    this.httpService.callGetService(`${this.config.getR_D_Users_List}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForDWM}`).subscribe((data: any) => {
      this.employeeList = data.data || [];
      this.getDWMSetup();
      // console.log('Employee List for the R&D Admin:', this.employeeList);
    });
  }

  //  ===================================== Add  New  Catogories ==========================================

  toggleAddCategory() {
    this.showAddCategoryInput = !this.showAddCategoryInput;
    this.newCategoryName = '';
  }

  editCategory(row: any) {
    this.allCategoriesList.forEach((item: any) => {
      item.editable = false;
    });
    row.editable = true;
  }

  validateInput(event: any) {
    const inputValue = event.target.value;
    event.target.value = inputValue.replace(/\s+/g, ' ');
  }

  preventNegative(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  //  ========================================= Create & Manage  Category ==================================

  getCategories() {
    this.httpService.callGetService(`${this.config.getCategoriesList}?companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
      // console.log('Categories List:', data);
      this.allCategoriesList = data.data.map((item: any) => ({
        ...item,
        id: item.categoryId
      }));
      this.allCategoriesList.reverse();
      // console.log('Categories List:', this.allCategoriesList);
    });
  }

  saveAddNewCategory(cat: any = null): void {
    // ===== Validation for ADD =====
    if (!cat && (!this.newCategoryName || this.newCategoryName.trim() === '')) {
      this.toastr.error('Please enter category', 'error');
      return;
    }

    // ===== Validation for UPDATE =====
    if (cat && (!cat.categoryName || cat.categoryName.trim() === '')) {
      this.toastr.error('Category name cannot be empty', 'Error');
      return;
    }
    const payload: any = {
      categoryId: null,
      companyId: this.loggedInUserCompanyID,
      categoryName: cat ? cat.categoryName : this.newCategoryName
    };
    if (cat && cat.id) {
      payload.categoryId = cat.categoryId;
    }
    this.httpService.callPostService(this.config.addCategory, payload).subscribe(
      (data: any) => {
        if (data?.status === true) {
          if (cat) {
            this.toastr.success('Category Updated Successfully', 'Success');
            cat.editable = false;
          } else {
            this.toastr.success('Category Added Successfully', 'Success');
            this.newCategoryName = '';
            this.showAddCategoryInput = false;
          }

          this.getCategories();
        } else {
          this.toastr.error('Something went wrong', 'Error');
        }
      },
      (error: any) => {
        this.toastr.error(error.error.message, 'Error');
      }
    );
  }

  //  ========================================= Delete Category ============================

  deleteCategory(cat: any) {
    const categoryId = cat.categoryId;
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      maxWidth: '450px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: {
        msg: 'Are you sure you want to delete ?',
        btn1: 'No',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Yes' || result === true) {
        this.httpService.callDeleteService(`${this.config.deleteCategory}?companyId=${this.loggedInUserCompanyID}&categoryId=${categoryId}`).subscribe(
          (data: any) => {
            if (data?.status === true) {
              this.toastr.success('Deleted successfully', 'Success');
              this.getCategories();
            } else {
              this.toastr.error(data?.message || 'Delete Failed', 'Error');
            }
          },
          (error: any) => {
            this.toastr.error(error?.error?.message || 'Delete Failed', 'Error');
          }
        );
      }
    });
  }

  cancelEdit(cat: any) {
    cat.editable = false;
    this.getCategories();
  }

  // ========================================= cancel setup ============================

  onClickDWMCancle() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      maxWidth: '450px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: {
        msg: 'Are you sure you want to discard changes ?',
        btn1: 'No',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Yes' || result === true) {
        this.router.navigate(['/home/hrportal/dwmplus']);
      }
    });
  }

  // ========================================= Save DWM Setup ============================

  saveSetupData() {
    // Cut-off date validation
    if (!this.cutOffDate || this.cutOffDate < 1 || this.cutOffDate > 31) {
      this.toastr.error('Enter valid Cut-off Date (1–31)');
      return;
    }

    //  R&D Admin validation
    if (!this.selectedSubAdmin) {
      this.toastr.error('Please select R&D Admin');
      return;
    }

    //  Monthly / Yearly required validation
    if (!this.validateOneRequired()) {
      this.toastr.error('Please enter Monthly or Annually DWM', 'Validation');
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      maxWidth: '450px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: {
        msg: 'Are you sure you want to save ?',
        btn1: 'No',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Yes' || result === true) {
        const payload: any = {
          companyId: this.loggedInUserCompanyID,
          fiscalYear: this.selectedYearForDWM,
          cutOffDate: this.cutOffDate,
          monthlyDwm: this.monthlyDwm,
          yearlyDwm: this.yearlyDwm,
          rndAdmin: this.selectedSubAdmin,
          eodReportTime: this.eodTime
        };

        if (this.dwmSetupId) {
          payload.id = this.dwmSetupId;
        }

        this.httpService.callPostService(this.config.saveDwmSetup, payload).subscribe(
          (data: any) => {
            if (data?.status === true) {
              this.toastr.success('Saved successfully', 'Success');
              this.getDWMSetup();
              this.setupSaved = true;
            }
          },
          (error: any) => {
            console.error('Server Error:', error);
          }
        );
      }
    });
  }

  getDWMSetup() {
    this.httpService.callGetService(`${this.config.getDwmSetup}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      this.resetSetupData();
      if (!res?.data?.length) return;
      const setup = res.data.find((x: any) => x.fiscalYear === this.selectedYearForDWM);
      if (!setup) return;
      this.dwmSetupId = setup.id;
      this.cutOffDate = Number(setup.cutOffDate);
      this.monthlyDwm = setup.monthlyDwm;
      this.yearlyDwm = setup.yearlyDwm;
      this.eodTime = setup.eodReportTime;
      this.selectedSubAdmin = setup.rndAdmin;
    });
  }

  canceldata() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      maxWidth: '450px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: {
        msg: 'Are you sure you want to discard changes?',
        btn1: 'No',
        btn2: 'Yes',
        btn2BgColor: 'red',
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Yes' || result === true) {
        this.dialogRef.close();
      }
    });
  }
}
